import { Actions, ActionTypes } from '@core/store/actions';
import { LoginMessage } from '@model';

export interface State {
  loginMessagesLoaded: boolean;
  loginMessagesLoading: boolean;
  loginMessages: LoginMessage[];
}

export const initialState: State = {
  loginMessagesLoaded: false,
  loginMessagesLoading: false,
  loginMessages: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.LoadLoginMessages:
      return { ...state, loginMessagesLoaded: false, loginMessagesLoading: true };

    case ActionTypes.LoadLoginMessagesSuccess:
      return {
        ...state,
        loginMessages: action.payload,
        loginMessagesLoaded: true,
        loginMessagesLoading: false
      };
    case ActionTypes.LoadLoginMessagesFail:
      return { ...state, loginMessagesLoaded: false, loginMessagesLoading: false };
  }
  return state;
}

export const getLoginMessages = (state: State) => state.loginMessages;
export const getLoginMessagesLoaded = (state: State) => state.loginMessagesLoaded;
